// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"65":"6770f1b0","502":"f1a87005"}[chunkId] + ".chunk.css");